export default __webpack_public_path__ + "static/Wallop-Heavy-158ba0983fbaca428be62ab0a9e18a56.woff2";